<template>
  <!-- PC端右侧底部弹框广告 -->
  <div class="popup-ad d-none d-lg-block" :class="{ 'show': isVisible, 'animate-in': animateIn, 'animate-out': animateOut }" v-if="shouldShow">
    <div class="popup-content" @click="handleContentClick">
      <!-- 关闭按钮 -->
      <button class="popup-close" @click="hideAd">
        <img src="@/assets/images/tcclose.png" alt="关闭">
      </button>

      <!-- 广告内容 -->
      <div class="popup-ad-content" v-if="adData && !isLoading && !hasError">
        <a :href="adData.url" target="_blank" @click="handleAdClick">
          <img :src="adData.cover" :alt="adData.title || '广告'" class="ad-image" @load="handleImageLoad">
        </a>
      </div>

      <!-- 加载状态 -->
      <div class="popup-loading" v-if="isLoading">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

      <!-- 错误状态 -->
      <div class="popup-error" v-if="hasError">
        <p>加载失败</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupAd',
  data() {
    return {
      isVisible: false,
      animateIn: false,
      animateOut: false,
      shouldShow: false,
      adData: null,
      isLoading: false,
      hasError: false,
      showDelay: 3000, // 3秒后显示
      hideTimeout: null,
      animationTimeout: null
    }
  },
  async mounted() {
    this.loadAdData();
  },
  beforeDestroy() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }
  },
  methods: {
    async loadAdData() {
      try {
        this.isLoading = true;
        this.hasError = false;
        this.shouldShow = true;

        // 模拟API调用获取广告数据
        const response = await this.$ajax('/common/popouList', {
          type: 'official'
        });
        var data = response.data[0]
        var adId = localStorage.getItem('popupAdid') ? JSON.parse(localStorage.getItem('popupAdid')) : []

        if (adId.length >= response.data.length) {
          adId = []
          localStorage.setItem('popupAdid', JSON.stringify(adId))
        }
        if (adId.length > 0) {
          adId.forEach((id, index) => {
            if (id == data.id) {
              data = response.data[index + 1]
            }
          })
        }
        if (!data) {
          data = response.data[0]
        }
        adId.push(data.id)
        localStorage.setItem('popupAdid', JSON.stringify(adId))
        if (data && data.id) {
          this.adData = data;
          this.isLoading = false;

          // 显示广告
          this.showAd();
        } else {
          this.hasError = true;
          this.isLoading = false;
        }
      } catch (error) {
        console.log('Failed to load popup ad data:', error);
        this.hasError = true;
        this.isLoading = false;
      }
    },

    async getPopupAdData() {
      // 模拟API调用
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            id: Date.now(),
            title: '游戏盒子广告',
            cover: '@/assets/images/ad.png',
            url: '#download'
          });
        }, 500);
      });
    },

    showAd() {
      this.isVisible = true;
      this.animateIn = true;
      this.animateOut = false;

      // 清除动画类
      this.animationTimeout = setTimeout(() => {
        this.animateIn = false;
      }, 500);
    },

    hideAd() {
      this.animateOut = true;
      this.animateIn = false;

      this.hideTimeout = setTimeout(() => {
        this.isVisible = false;
        this.shouldShow = false;
        this.animateOut = false;
      }, 400);
    },

    handleContentClick(event) {
      // 阻止点击内容区域时关闭弹窗
      event.stopPropagation();
    },

    handleAdClick() {
      // 点击广告时触发下载事件
      this.$emit('download');
      this.hideAd();
    },

    handleImageLoad() {
      // 图片加载完成后的处理
      console.log('Popup ad image loaded');
    }
  }
}
</script>

<style scoped>
</style>